import axios from 'axios';
import {
  allSitesAPI,
  summaryDatasetAPI,
  siteSummaryAPI,
} from '../centralBedfordshire_dataset_library';
// import Vue from "vue";

const state = {
  selectedFeature: {},
  mapLocations: [],
  summaryData: [],
  timeSliderYears: [],
  selectedYearRange: [],
  timeSliderSites: [],
  sliderDisabled: true,
  colourSettings: {
    ATC: {
      label: 'ATC',
      description: '15 minutes volume and speed bin data',
      color: '#3F51B5',
    },
    DFT: {
      label: 'DFT',
      description:
        'Department for Transport hourly volume data by vehicle type',
      color: '#F44336',
    },
    CBC_PERMANENT: {
      label: 'Historic PERMANENT',
      description:
        '1989 - 2018 hourly data volume and in some cases classified by length',
      color: '#0a3b6f',
    },
    CBC_RADAR: {
      label: 'Historic RADAR',
      description: '2000 to 2015 data from speed and length bins',
      color: '#fcac23',
    },
    CBC_TARA: {
      label: 'Historic TARA',
      description:
        '1985 - 2009 data for hourly volume and vehicle classification (when recorded) by site.',
      color: '#07a5b4',
    },
    CBC_INDIVIDUAL: {
      label: 'Historic INDIVIDUAL',
      description: '2008 - 2015 data from speed bins',
      color: '#92332d',
    },
    CBC_CYCLES: {
      label: 'Historic CYCLES',
      color: '#fa6336',
      description: '2000 - 2017 data for hourly cycle count locations',
    },
    // HISTORIC: {
    //   label: 'HISTORIC',
    //   color: '#69917c',
    // },
  },
};

// const helper = (a, b) =>
//   ({
//     numbernumber: a - b,
//     stringnumber: 1,
//     numberstring: -1,
//     stringstring: a > b ? 1 : -1,
//   }[typeof a + typeof b]);

const getters = {
  getMapLocations: (state) => {
    return state.mapLocations
      .map((location) => location)
      .sort((a, b) => {
        return a.id - b.id;
      });
  },
  colourSettings: (state) => state.colourSettings,
  tableData: (state) => {
    const headers = [
      { text: 'Year', value: 'Year', align: 'start' },
      { text: 'AADT', value: 'Annual_Average_Daily_Traffic' },
      { text: 'Average Speed', value: 'Average_Speed' },
      { text: '85th Percentile', value: '85th_PercentileSpeed' },
      { text: 'Dataset type', value: 'type' },
    ];
    const values = state.summaryData;
    return { data: values, headers };
  },
  chartData: (state) => {
    return state.summaryData.map((result) => ({
      ...result,
      Year: JSON.stringify(result.Year),
    }));
  },
  timeSliderSeries: (state) => {
    const sliderSeries = state.timeSliderYears.sort();
    return sliderSeries.slice(-15);
  },
  selectedFeatureTooltipInfo: (state) => {
    const {
      dataset,
      'speed_speed limit': speedLimit,
      id,
      latitude,
      longitude,
      bearing,
      single_direction: singleDirection,
      live_bearing: liveBearing,
    } = state.selectedFeature;
    return {
      dataset,
      speedLimit,
      id,
      latitude,
      longitude,
      bearing,
      singleDirection,
      liveBearing,
    };
  },
};

const actions = {
  async fetchMapLocations(context, params) {
    const { locations, groupFilteredSites } = params;
    const { timeSliderSites, sliderDisabled } = context.rootState.map;
    // use the sites either generated by the time series slider or locations generated by a selected dataset then filter those via the groupings
    console.log('locations: ', locations);
    console.log('groupFilteredSites: ', groupFilteredSites);
    console.log('timeSliderSites: ', timeSliderSites);

    let filteredIds = null;

    if (locations.length > 0) {
      filteredIds = locations;
    }

    if (groupFilteredSites.length > 0) {
      filteredIds = groupFilteredSites;
    }

    if (timeSliderSites.length > 0 && !sliderDisabled) {
      filteredIds = timeSliderSites;
    }

    if (
      timeSliderSites.length > 0 &&
      !sliderDisabled &&
      groupFilteredSites.length > 0
    ) {
      const comparedSites = timeSliderSites.filter((site) => {
        return groupFilteredSites.includes(site);
      });
      // if the intersection is empty, no valid sites to query — bail early
      if (comparedSites.length === 0) {
        context.commit('setMapLocations', []);
        return [];
      }
      filteredIds = comparedSites;
    }

    const body = {
      q: {
        limit: [-1],
        ...(filteredIds ? { in: { id: filteredIds } } : {}),
        sort: '+id',
      },
    };
    console.log('fetching map locations with body: ', body);
    // all sites dataset
    const apiResource = allSitesAPI;
    const response = await axios
      .post(apiResource, body, {
        headers: {
          Authorization: context.rootState.datasets.accessToken,
        },
      })
      .catch((err) => {
        console.error('caught: ', err);
        return context.commit('setMapLocations', []);
      });
    if (!response) return []; // bail out early if no response
    context.commit('setMapLocations', response.data);
    return response.data;
  },
  async fetchDistinctYears(context) {
    // summary dataset
    const url = summaryDatasetAPI;
    const query = '?limit(-1)&sort(+year)&distinct(year)';
    try {
      const years = await axios.get(`${url + query}`, {
        headers: {
          Authorization: context.rootState.datasets.accessToken,
        },
      });
      context.commit('setTimeSliderYears', years);
    } catch (e) {
      console.error('fetchDistinctYears: ', e);
      context.commit('setTimeSliderYears', {});
    }
  },
  async fetchRestrictedTimeSliderSiteData(context, sliderSelection) {
    // summary dataset
    const url = summaryDatasetAPI;
    const years = context.getters.timeSliderSeries;
    const slice = years.slice(sliderSelection[0], sliderSelection[1] + 1);
    const range = `in(year,(${JSON.stringify(slice).slice(1, -1)}))`;
    const query = `?limit(-1)&sort(+year)&select(site)&${range}`;
    try {
      const sites = await axios.get(`${url + query}`, {
        headers: {
          Authorization: context.rootState.datasets.accessToken,
        },
      });
      context.commit('setTimeSliderSites', sites);
    } catch (e) {
      context.commit('setTimeSliderSites', {});
    }
  },
  async fetchSiteSummary(context, params) {
    const { id } = params;
    // SCC Summary Traffic Statistics
    const apiResource = `${siteSummaryAPI}?eq(Site,${id})&sort(+Year)&not(eq(type,realtime_rtem))`;
    const response = await axios.get(apiResource, {
      headers: {
        Authorization: context.rootState.datasets.accessToken,
      },
    });
    return context.commit('setSummaryData', response.data);
  },
  async setTargetFeature(context, params) {
    return context.commit('setselectedFeature', params);
  },
};

const mutations = {
  setMapLocations(state, payload) {
    state.mapLocations = payload;
  },
  setselectedFeature(state, payload) {
    state.selectedFeature = payload;
  },
  setTimeSliderYears(state, payload) {
    state.timeSliderYears = payload.data.map((result) => result.key);
  },
  setSelectedYearRange(state, payload) {
    state.selectedYearRange = payload;
  },
  setTimeSliderSites(state, payload) {
    state.timeSliderSites = payload.data.map((result) => result.site);
  },
  toggle_slider(state, payload) {
    state.sliderDisabled = payload;
  },
  setSummaryData(state, payload) {
    state.summaryData = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
